import axios from "axios";
import React, { useState, useEffect, useRef } from "react";
import { Row, Col } from "react-bootstrap";
import { Label, Input, Button } from "reactstrap";
import { Routes } from "../../../configurations/config";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { LeaveManagmentAPIs } from "../LeaveManagmentAPIs";
import { UserConsumer } from "../../../UserContext";
import moment from "moment";
import { AlertPopups } from "../../../components/AlertPopups";
import { APIDateFormat } from "../../Dashboard/DashboardVariables";
import LeaveForm from "./LeaveForm";

const LeaveApplication = (props) => {
	let token = null;
	const { id } = useParams();
	const history = useHistory();
	const { state } = useLocation();
	const startDatepickerRef = useRef(null);
	const endDatepickerRef = useRef(null);
	const [flag, setFlag] = useState(true);
	const [duration, setDuration] = useState();
	const leaveStatus = state ? state.status : "Draft";
	const initialValues = {
		LeaveStartDate: "",
		LeaveEndDate: null,
		LeaveDuration: "",
		LeaveReason: "",
		EmployeeComments: "",
		LeaveType: "",
		leaveApplicationStatus: "Draft",
		supervisorComments: "",
		adminComments: "",
	};
	const [formFields, setFormFields] = useState(initialValues);
	const [leavetypes, setleavetypes] = useState();
	const [fileErr, setFileErr] = useState(false);
	const [attachment, setAttachment] = useState("");
	const [attachedFileName, setAttachedFileName] = useState("");
	const [disableEndDate, setdisableEndDate] = useState(!id);

	const leaveDuration = [
		{ value: 0.5, label: "Short Leave" },
		{ value: 1, label: 1 },
		{ value: 1.5, label: 1.5 },
		{ value: 2, label: 2 },
		{ value: 2.5, label: 2.5 },
		{ value: 3, label: 3 },
		{ value: 3.5, label: 3.5 },
		{ value: 4, label: 4 },
		{ value: 4.5, label: 4.5 },
		{ value: 5, label: 5 },
		{ value: 5.5, label: 5.5 },
		{ value: 6, label: 6 },
		{ value: 6.5, label: 6.5 },
		{ value: 7, label: 7 },
		{ value: 7.5, label: 7.5 },
		{ value: 8, label: 8 },
		{ value: 8.5, label: 8.5 },
		{ value: 9, label: 9 },
		{ value: 9.5, label: 9.5 },
		{ value: 10, label: 10 },
		{ value: 10.5, label: 10.5 },
		{ value: 11, label: 11 },
		{ value: 11.5, label: 11.5 },
		{ value: 12, label: 12 },
		{ value: 12.5, label: 12.5 },
		{ value: 13, label: 13 },
		{ value: 13.5, label: 13.5 },
		{ value: 14, label: 14 },
		{ value: 14.5, label: 14.5 },
		{ value: 15, label: 15 },
		{ value: 15.5, label: 15.5 },
		{ value: 16, label: 16 },
		{ value: 16.5, label: 16.5 },
		{ value: 17, label: 17 },
		{ value: 17.5, label: 17.5 },
		{ value: 18, label: 18 },
		{ value: 18.5, label: 18.5 },
		{ value: 19, label: 19 },
		{ value: 19.5, label: 19.5 },
		{ value: 20, label: 20 },
		{ value: 20.5, label: 20.5 },
		{ value: 21, label: 21 },
		{ value: 21.5, label: 21.5 },
		{ value: 22, label: 22 },
		{ value: 22.5, label: 22.5 },
		{ value: 23, label: 23 },
		{ value: 23.5, label: 23.5 },
		{ value: 24, label: 24 },
		{ value: 24.5, label: 24.5 },
		{ value: 25, label: 25 },
		{ value: 25.5, label: 25.5 },
		{ value: 26, label: 26 },
		{ value: 26.5, label: 26.5 },
		{ value: 27, label: 27 },
		{ value: 27.5, label: 27.5 },
		{ value: 28, label: 28 },
		{ value: 28.5, label: 28.5 },
		{ value: 29, label: 29 },
		{ value: 29.5, label: 29.5 },
		{ value: 30, label: 30 },
		{ value: 30.5, label: 30.5 },
		{ value: 31, label: 31 },
		{ value: 31.5, label: 31.5 },
	];

	useEffect(() => {
		let header = { Authorization: `Bearer ${token}` };
		axios
			.get(`${LeaveManagmentAPIs.GetLeaveTypesAPI}`, {
				headers: header,
			})
			.then(({ data, status }) => {
				if (status === 200) {
					setleavetypes(
						data.types.sort((a, b) =>
							a.label.localeCompare(b.label)
						)
					);
				}
			});
		if (id) {
			axios
				.get(`${LeaveManagmentAPIs.GetLeave}/${id}`, {
					headers: { Authorization: `Bearer ${token}` },
				})
				.then(({ data }) => {
					setFormFields({
						LeaveStartDate: new Date(data.leaveStartDate),
						LeaveEndDate: new Date(data.leaveEndDate),
						LeaveReason: data.leaveReason,
						LeaveDuration: data.leaveDuration,
						EmployeeComments: data.employeeComments,
						leaveApplicationStatus: data.leaveApplicationStatus,
						supervisorComments: data.supervisorComments,
						adminComments: data.adminManagerComments,
						adminManagerComments: data.adminManagerComments,
						adminName: data.adminName,
						supervisorName: data.supervisorName,
						supervisorStatus: data.supervisorStatus,
						adminStatus: data.adminStatus,
						adminLastUpdatedDate: data.adminLastUpdatedDate,
						supervisorLastUpdatedDate:
							data.supervisorLastUpdatedDate,
						LeaveType: mapLeaveType(data.leaveType),
					});
					setDuration({
						value: data.leaveDuration,
						label: data.leaveDuration,
					});
					setAttachment(data.attachmentFile);
					setAttachedFileName(data.attachmentFile);
					props.FormStatus(data.leaveApplicationStatus);
				});
		}
		props.FormStatus(formFields.leaveApplicationStatus);
	}, []);

	useEffect(() => {
		getLeaveDuration();
	}, [formFields.LeaveStartDate, formFields.LeaveEndDate]);

	const mapLeaveType = (leaveType) => {
		switch (leaveType) {
			case 1:
				return { value: leaveType, label: "Sick" };
			case 2:
				return { value: leaveType, label: "Casual" };
			case 3:
				return { value: leaveType, label: "Annual earned" };
			case 4:
				return { value: leaveType, label: "Without Pay" };
			case 6:
				return { value: leaveType, label: "Compensation" };
			case 7:
				return { value: leaveType, label: "Special Leave" };
			case 11:
				return { value: leaveType, label: "Maternity" };
			default:
				return null;
		}
	};
	function renderButtons(id, leaveStatus) {
		if (id && leaveStatus === "Pending") {
			return (
				<div className="mt-2">
					<Button
						className="delete-btn leftBtn"
						onClick={handleDelete}
					>
						Delete
					</Button>
					<Button
						className="submit-btn leftBtn"
						onClick={() => {
							updateLeaveApplication();
						}}
					>
						Update
					</Button>
					<Button className="reset-btn" onClick={handleReset}>
						Reset
					</Button>
				</div>
			);
		} else if (!id) {
			return (
				<>
					<input
						type="submit"
						className="submit-btn leftBtn"
						onClick={handleSubmit}
						value="Submit"
					/>
					<Button className="reset-btn" onClick={handleReset}>
						Reset
					</Button>
				</>
			);
		}

		return null;
	}

	const handleChange = (e) => {
		setFormFields({ ...formFields, [e.target.name]: e.target.value });
	};
	const startDate = moment(formFields.LeaveStartDate).format(APIDateFormat);
	const endDate = moment(formFields.LeaveEndDate).format(APIDateFormat);

	//API to get leave duration
	const getLeaveDuration = () => {
		const header = { Authorization: `Bearer ${token}` };
		{
			!flag &&
				axios
					.get(
						`${LeaveManagmentAPIs.CalculateLeaveDurationAPI}?StartDate=${startDate}&endDate=${endDate}`,
						{
							headers: header,
						}
					)
					.then(({ data }) => {
						if (startDate > endDate) {
							AlertPopups.ErrorAlert.fire({
								text: "Start Date is greater then end Date",
							});
							setFormFields({
								...formFields,
								["LeaveDuration"]: null,
								["LeaveEndDate"]: null,
							});
							setDuration({ value: null, label: null });
						} else {
							setFormFields({
								...formFields,
								["LeaveDuration"]: {
									value: data.duration,
									label: data.duration,
								},
							});
							setDuration({
								value: data.duration,
								label: data.duration,
							});
						}
					});
		}
	};

	const getDurationEndDate = (obj) => {
		setDuration({ value: obj.value, label: obj.label });
		setFlag(true);
		setFormFields({
			...formFields,
			["LeaveDuration"]: { value: obj.value, label: obj.label },
		});
		const header = { Authorization: `Bearer ${token}` };
		startDate &&
			axios
				.get(
					`${LeaveManagmentAPIs.CalculateLeaveDurationAPI}?StartDate=${startDate}&Duration=${obj.value}`,
					{ headers: header }
				)
				.then(({ data }) => {
					const { endDate } = data;
					setFormFields({
						...formFields,
						["LeaveEndDate"]: moment(endDate).toDate(),
						["LeaveDuration"]: {
							value: data.duration,
							label: data.duration,
						},
					});
				})
				.catch((err) => {
					AlertPopups.ErrorAlert.fire({
						text: "Select Start Date First",
					});
					setFormFields({ ...formFields, ["LeaveDuration"]: null });
				});
	};
	const startdatehandleChange = (date) => {
		setFormFields({
			...formFields,
			["LeaveStartDate"]: date,
		});
		setdisableEndDate(false);
		setFlag(false);
	};
	const datehandleChange = (date) => {
		setFormFields({
			...formFields,
			["LeaveEndDate"]: date,
		});
		setFlag(false);
	};
	//for creating leave
	const {
		employeeEmergencyContactName,
		employeeEmergencyContactAddress,
		employeeEmergencyContactPhone1,
		employeeEmergencyContactPhone2,
	} = props.emgContact;

	const handleSubmit = () => {
		let formdata = new FormData();
		formdata.append("LeaveStartDate", startDate);
		formdata.append("LeaveEndDate", endDate);
		formdata.append("LeaveType", formFields.LeaveType.value);
		formdata.append("LeaveReason", formFields.LeaveReason);
		formdata.append("EmployeeComments", formFields.EmployeeComments);
		formdata.append("LeaveDuration", duration.value);
		formdata.append(
			"EmployeeEmergencyContactName",
			employeeEmergencyContactName
		);
		formdata.append(
			"EmployeeEmergencyContactAddress",
			employeeEmergencyContactAddress
		);
		formdata.append(
			"EmployeeEmergencyContactPhone1",
			parseInt(employeeEmergencyContactPhone1)
		);
		formdata.append(
			"EmployeeEmergencyContactPhone2",
			parseInt(employeeEmergencyContactPhone2)
		);
		if (attachment !== null) {
			formdata.append("AttachmentFile", attachment);
		}
		axios
			.post(`${LeaveManagmentAPIs.CreateLeaveAPI}`, formdata, {
				headers: {
					"Content-Type": "multipart/form-data",
					Authorization: `Bearer ${token}`,
				},
			})
			.then(({ status }) => {
				if (status === 200) {
					AlertPopups.successAlert.fire({
						text: "Leave Application Submitted",
					});
					history.push(Routes.ManageLeavesView);
				} else {
					AlertPopups.ErrorAlert.fire({
						text: "Leave Application Submission Error",
					});
				}
			})
			.catch((err) => {
				if (err.response) {
					AlertPopups.ErrorAlert.fire({
						text: `${err.response.data.message}`,
					});
				} else
					AlertPopups.ErrorAlert.fire({
						text: "Leave Application Submission Error",
					});
			});
	};
	const handleReset = () => {
		setFormFields({
			...formFields,
			LeaveStartDate: "",
			LeaveEndDate: null,
			LeaveDuration: "",
			LeaveReason: "",
			EmployeeComments: "",
			LeaveType: "",
		});
		setDuration(null);
		handleRemoveAttachement();
	};

	const handleDelete = () => {
		AlertPopups.confirmBox
			.fire({
				text: "Delete Leave Request?",
			})
			.then((result) => {
				if (result.value) {
					return axios
						.delete(`${LeaveManagmentAPIs.DeleteLeave}/${id}`, {
							headers: { Authorization: `Bearer ${token}` },
						})
						.then(({ status }) => {
							if (status === 200) {
								AlertPopups.successAlert.fire({
									text: "Leave Application Deleted",
								});
								history.push(Routes.ManageLeavesView);
							} else {
								AlertPopups.ErrorAlert.fire({
									text: "Leave Application Deletion Error",
								});
							}
						});
				}
			});
	};

	const updateLeaveApplication = () => {
		let formdata = new FormData();
		formdata.append("LeaveStartDate", startDate);
		formdata.append("LeaveEndDate", endDate);
		formdata.append("LeaveType", formFields.LeaveType?.value);
		formdata.append("LeaveReason", formFields.LeaveReason);
		formdata.append("EmployeeComments", formFields.EmployeeComments);
		formdata.append("LeaveDuration", duration?.value);
		formdata.append(
			"EmployeeEmergencyContactName",
			employeeEmergencyContactName
		);
		formdata.append(
			"EmployeeEmergencyContactAddress",
			employeeEmergencyContactAddress
		);
		formdata.append(
			"EmployeeEmergencyContactPhone1",
			parseInt(employeeEmergencyContactPhone1)
		);
		formdata.append(
			"EmployeeEmergencyContactPhone2",
			parseInt(employeeEmergencyContactPhone2)
		);
		if (attachment !== null) {
			formdata.append("AttachmentFile", attachment);
		}

		axios
			.put(`${LeaveManagmentAPIs.UpdateLeaveAPI}/${id}`, formdata, {
				headers: {
					"Content-Type": "multipart/form-data",
					Authorization: `Bearer ${token}`,
				},
			})
			.then((res) => {
				if (res.status === 200) {
					AlertPopups.successAlert.fire({
						text: "Leave Application Updated",
					});
					history.push(Routes.ManageLeavesView);
				} else {
					AlertPopups.ErrorAlert.fire({
						text: "Leave Application Updation Error",
					});
				}
			})
			.catch((err) => {
				if (err.response) {
					AlertPopups.ErrorAlert.fire({
						text: `${err.response.data.message}`,
					});
				} else
					AlertPopups.ErrorAlert.fire({
						text: "Leave Application Updation Error",
					});
			});
	};
	const handleAddAttachement = (temp) => {
		if (temp.target.files[0] !== undefined) {
			setFileErr(false);
			if (
				[
					"image/jpeg",
					"image/jpg",
					"image/png",
					"application/pdf",
					"application/msword",
				].includes(temp.target.files[0].type)
			) {
				setAttachment(temp.target.files[0]);
			} else {
				setFileErr(true);
			}
		}
	};
	const handleRemoveAttachement = () => {
		document.getElementById("attachment").value = null;
		setAttachment("");
		setAttachedFileName("");

		if (document.getElementById("icon")) {
			document.getElementById("icon").remove();
		}
	};
	const AddHoursinTimesheet = () => {
		axios
			.get(
				`${LeaveManagmentAPIs.AddHoursInTimesheet}/ReviewedLeaveApplications/${id}/AddHoursToTimesheet`,
				{
					headers: {
						Authorization: `Bearer ${token}`,
					},
				}
			)
			.then((res) => {
				if (res.status === 200) {
					AlertPopups.successAlert.fire({
						text: "Hours Added In Timesheet",
					});
					history.push("/ManageLeavesView");
				} else {
					AlertPopups.ErrorAlert.fire({
						text: "Error",
					});
				}
			})
			.catch((err) => {
				if (err.response) {
					AlertPopups.ErrorAlert.fire({
						text: `${err.response.data.message}`,
					});
				} else
					AlertPopups.ErrorAlert.fire({
						text: "Error",
					});
			});
	};
	const getImageByStatus = (status) => {
		switch (status) {
			case 2:
				return (
					<img
						title="Rejected"
						src="https://teo-staging.teo-intl.com/Assets/images/pages/rejected.png"
					/>
				);
			case 3:
				return (
					<img
						title="Approved"
						src="https://teo-staging.teo-intl.com/Assets/images/pages/approved.jpg"
					/>
				);
			case 4:
				return (
					<img
						title="Invalid"
						src="https://teo-staging.teo-intl.com/Assets/images/pages/invalid.png"
					/>
				);
			default:
				return (
					<img
						title="Pending"
						src="https://teo-staging.teo-intl.com/Assets/images/pages/pending.png"
					/>
				);
		}
	};

	const openStartDatepicker = () => {
		const datepickerElement = startDatepickerRef.current;
		datepickerElement.setFocus(true);
	};
	const openEndDatepicker = () => {
		const datepickerElement = endDatepickerRef.current;
		datepickerElement.setFocus(true);
	};

	const onLeaveTypeChange = (value) => {
		setFormFields({
			...formFields,
			["LeaveType"]: value,
		});
	};

	return (
		<UserConsumer>
			{(userDatails) => {
				token = userDatails.token;
				return (
					<>
						<LeaveForm
							id={id}
							formFields={formFields}
							handleSubmit={handleSubmit}
							leaveStatus={leaveStatus}
							disableEndDate={disableEndDate}
							leavetypes={leavetypes}
							duration={duration}
							leaveDuration={leaveDuration}
							datehandleChange={datehandleChange}
							handleChange={handleChange}
							startdatehandleChange={startdatehandleChange}
							openStartDatepicker={openStartDatepicker}
							openEndDatepicker={openEndDatepicker}
							startDatepickerRef={startDatepickerRef}
							endDatepickerRef={endDatepickerRef}
							attachedFileName={attachedFileName}
							handleAddAttachement={handleAddAttachement}
							fileErr={fileErr}
							attachment={attachment}
							handleRemoveAttachement={handleRemoveAttachement}
							AddHoursinTimesheet={AddHoursinTimesheet}
							handleDelete={handleDelete}
							handleReset={handleReset}
							updateLeaveApplication={updateLeaveApplication}
							getDurationEndDate={getDurationEndDate}
							onLeaveTypeChange={onLeaveTypeChange}
						/>

						{id && (
							<div
								className={`${
									(id && leaveStatus === "Approved") ||
									(id && leaveStatus === "Pending")
										? "pt-5 mt-2"
										: "pt-3"
								} `}
								style={{ backgroundColor: "white" }}
							>
								<div className="my-3 formInfoContainer">
									<div className="formInfoContainerHeader">
										<Label sm={12}>
											Application Status
										</Label>
									</div>
									<Row className="py-2 px-3">
										<Col lg={3}>
											<Row>
												<div className="px-4 formDetailHeader">
													Approvers
												</div>
											</Row>
											<p className="px-2 formValueContainer">
												{formFields.supervisorName}
											</p>
											<p className="px-2 my-2 formValueContainer">
												{formFields.adminName}
											</p>
										</Col>
										<Col lg={3}>
											<Row>
												<div className="px-4 formDetailHeader">
													Application Status
												</div>
											</Row>
											<div className="px-5 formDetailHeader">
												<p className="formValueContainer">
													{formFields.supervisorStatus
														? getImageByStatus(
																formFields.supervisorStatus
														  )
														: null}
												</p>
											</div>
											<div className="px-5 my-2 formDetailHeader">
												<p className="formValueContainer">
													{formFields.adminStatus
														? getImageByStatus(
																formFields.adminStatus
														  )
														: null}
												</p>
											</div>
										</Col>
										<Col lg={3}>
											<Row>
												<div className="px-4 formDetailHeader">
													Comments
												</div>
											</Row>
											<div className="px-2 mr-5">
												<Input
													type="textarea"
													name="supComments"
													disabled={true}
													className="supDesciptionBox"
													value={
														formFields.supervisorComments
													}
												/>
											</div>
											<div className="px-2 mr-5">
												<Input
													type="textarea"
													disabled={true}
													name="adminMgrComments"
													className="my-2 supDesciptionBox"
													value={
														formFields.adminManagerComments
													}
												/>
											</div>
										</Col>
										<Col lg={3}>
											<Row>
												<div className="px-4 formDetailHeader">
													Last Updated Date
												</div>
											</Row>
											<p className="px-2 formValueContainer">
												{formFields.supervisorLastUpdatedDate
													? moment(
															formFields.supervisorLastUpdatedDate
													  ).format(
															"DD/MM/YYYY HH:mm"
													  )
													: null}
											</p>
											<p className="px-2 my-3 formValueContainer">
												{formFields.adminLastUpdatedDate
													? moment(
															formFields.adminLastUpdatedDate
													  ).format(
															"DD/MM/YYYY HH:mm"
													  )
													: null}
											</p>
										</Col>
									</Row>
								</div>
							</div>
						)}
					</>
				);
			}}
		</UserConsumer>
	);
};
export default LeaveApplication;
